import {
  Component,
  OnInit,
  Input,
} from '@angular/core';
import { UserDocument } from '../../interfaces/user-document.interface';
import {
  Firestore,
  collection,
  query,
  where,
  getDoc,
  getDocs,
  addDoc,
  DocumentReference,
} from '@angular/fire/firestore';
import { Storage, getDownloadURL, ref } from '@angular/fire/storage';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchResult } from '../../interfaces/searchResult.interface';
import { Service } from '../../interfaces/service.interface';
import { Timestamp } from 'firebase/firestore';
import { DecimalPipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { DiamondService } from '../../services/diamond.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-danhSachDichVu',
  templateUrl: './danhSachDichVu.component.html',
  styleUrls: ['./danhSachDichVu.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class DanhSachDichVu implements OnInit {

  @Input() userData!: UserDocument;
  @Input() userDocRef!: DocumentReference;
  
  allServices: Service[] = [];

  selectedService: Service | null = null;
  imageUrls: string[] = [];
  selectedImage: string | null = null;

  constructor(
    private firestore: Firestore,
    public docModal: NgbModal,
    private storage: Storage,
    private toastr: ToastrService,
    private diamondService: DiamondService,
  ) {
    this.fetchAllServices();
  }

  private async fetchAllServices(): Promise<void> {
    if (this.allServices.length > 0) {
      console.log('Dữ liệu dịch vụ đã được tải trước đó:', this.allServices);
      return;
    }

    try {
      const servicesRef = collection(this.firestore, 'services');
      const querySnapshot = await getDocs(servicesRef);

      this.allServices = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      } as Service));

      console.log('All services loaded:', this.allServices);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  }

  ngOnInit(): void {
    console.log('UserListComponent initialized.');
  }

  async selectService(service: Service, modal: any): Promise<void> {
    this.selectedService = service; // Gán dịch vụ được chọn
    await this.loadImages(); // Tải hình ảnh trước khi mở modal
    this.docModal.open(modal); // Mở modal
  }

  isLoadingImages: boolean = false;

  async loadImages(): Promise<void> {
    this.isLoadingImages = true;
    this.imageUrls = [];
    if (this.selectedService?.serviceImages) {
      for (const imageRef of this.selectedService.serviceImages) {
        try {
          const url = await getDownloadURL(ref(this.storage, imageRef));
          this.imageUrls.push(url);
        } catch (error) {
          console.error('Error loading image:', error);
        }
      }
    }
    this.isLoadingImages = false;
  }

  async getProviderEmail(providerRef: DocumentReference): Promise<string> {
    if (!providerRef) return '';

    try {
      // Truy vấn document của provider để lấy email
      const providerDoc = await getDoc(providerRef);
      if (providerDoc.exists()) {
        return providerDoc.data().email || '';  // Trả về email nếu có, nếu không trả về chuỗi rỗng
      } else {
        return '';  // Nếu document không tồn tại, trả về chuỗi rỗng
      }
    } catch (error) {
      console.error('Error fetching provider email:', error);
      return '';
    }
  }
  
  async savePlans(modal: any): Promise<void> {
    const diamondCost = this.selectedService?.price || 0;
  
    const clientPhone = prompt('Vui lòng nhập số điện thoại của khách hàng:');
    const address = prompt('Vui lòng nhập địa chỉ của khách hàng:');
  
    if (!clientPhone || !address) {
      console.warn('Số điện thoại và địa chỉ không được để trống.');
      return;
    }
  
    try {
      // First attempt to deduct diamonds
      const paymentSuccess = await this.diamondService.spendDiamond(
        this.userDocRef,
        this.userData,
        diamondCost
      );
  
      if (!paymentSuccess) {
        this.toastr.warning('Không thể thanh toán, vui lòng thử lại', 'Cảnh báo');
        return;
      }
  
      // Only save the plan if payment succeeds
      const providerEmail = await this.getProviderEmail(this.selectedService.provider) || 'pkthienbinh@gmail.com';
  
      const planData: SearchResult = {
        clientEmail: this.userData.email,
        clientUid: this.userDocRef.id,
        createdAt: Timestamp.fromDate(new Date()),
        providerEmail: providerEmail,
        guide: null,
        history: this.selectedService
          ? [`${this.selectedService.name}: ${this.selectedService.price}`]
          : [],
        clientPhone: clientPhone,
        address: address,
        alarm: true,
      };
  
      // Lưu vào subcollection plans của provider
      const providerDocRef = this.selectedService.provider;
      const plansCollectionRef = collection(providerDocRef, 'plans');
      await addDoc(plansCollectionRef, planData);
  
      this.toastr.success(`Chúng tôi sẽ liên hệ lại!`, 'Yêu cầu thành công');
      modal.close();
    } catch (error) {
      console.error('Error processing plan: ', error);
      this.toastr.error('Đã xảy ra lỗi khi đặt dịch vụ', 'Lỗi');
    }
  }
  
}
